import React, { useState, useEffect, useCallback } from "react";
import swal from "sweetalert";
import { useNavigate, Link } from "react-router-dom";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { getJobDetailsAPI, updateJobAPI, jobCompanyList } from "../../api/job";
import { getAllSkills, getAllCities, uploadImage } from "../../api/common";
//import { CKEditor } from "@ckeditor/ckeditor5-react";
//import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { job_types } from "../../common/job_types";
import DraftEditor from "../App/Common/DraftEditor";
import { useSelector } from "react-redux";

const initialState = {
  company_id: "",
  company_name: "",
  job_title: "",
  min_experience: 0,
  max_experience: 0,
  locations: [],
  skills: [],
  job_position: "",
  job_ctc: "",
  job_details: "",
  job_sector: "0",
  job_types: [],
  published: "0",
  job_publish_schedule: new Date(),
  application_deadline: new Date(),
  add_to_hot_jobs: "0",
  show_popup_how_did_you_know: false,
  profile_image: "",
  identity: "",
  industryicon:"we-are-hiring-2"
};

const EditJobs = () => {
  const [data, setData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [skills, setSkills] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [locations, setLocations] = useState([]);
  const [errors, setErrors] = useState({});
  const [jobTypes, setJobTypes] = useState(job_types);
  const navigate = useNavigate();
  const jobId = localStorage.getItem("nid");

  const [editorData, setEditorData] = useState({});

  const roleID = useSelector((state) => state.auth?.auth?.roleid);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const skillsData = await getAllSkills();
        setSkills(skillsData);
        const locationsData = await getAllCities();
        setLocations(locationsData);
        const cmp = await jobCompanyList();
        setCompanies(cmp);
        if (jobId) {
          const jobDetails = await getJobDetailsAPI(jobId);
          let skillArr = jobDetails.skills?.split(",");
          let skillsArr = skillsData.filter((s) => {
            return skillArr.includes(`${s.id}`);
          });

          let locArr = jobDetails.locations?.split(",");
          let locsArr = locationsData.filter((s) => {
            return locArr.includes(`${s.id}`);
          });

          let jtArr = jobDetails.job_types?.split(",");
          let jtsArr = jobTypes.filter((s) => {
            return jtArr.includes(`${s.id}`);
          });

          setData({
            ...data,
            ...jobDetails,
            job_publish_schedule: new Date(jobDetails.job_publish_schedule),
            application_deadline: new Date(jobDetails.application_deadline),
            skills: skillsArr?.map((skill) => ({
              value: skill.id,
              label: skill.skill_title,
            })),
            locations: locsArr?.map((loc) => ({
              value: loc.id,
              label: loc.city_name,
            })),
            job_types: jtsArr?.map((jt) => ({ value: jt.id, label: jt.title })),
          });

          setEditorData({ job_details: data?.job_details });
        }
      } catch (error) {
        swal("Error", "Failed to fetch data", "error");
      }
    };
    fetchData();
  }, [jobId]);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    if (file) {
      formData.append("file", file);
      const response = await uploadImage(formData);
      if (response !== false) {
        setData({ ...data, profile_image: response.data });
        swal("Success", "Image uploaded successfully", "success");
      } else {
        swal("Error", "Image upload failed", "error");
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSkillsChange = (selectedOptions) => {
    setData((prevState) => ({
      ...prevState,
      skills: selectedOptions,
    }));
  };

  const handleLocationsChange = (selectedOptions) => {
    setData((prevState) => ({
      ...prevState,
      locations: selectedOptions,
    }));
  };

  const handleJobTypesChange = (selectedOptions) => {
    setData((prevState) => ({
      ...prevState,
      job_types: selectedOptions,
    }));
  };

  const handleDateChange = (date, name) => {
    setData((prevState) => ({
      ...prevState,
      [name]: date,
    }));
  };

  const validate = () => {
    let tempErrors = {};
    //tempErrors.company_id = data.company_id ? "" : "This field is required.";
    tempErrors.job_title = data.job_title ? "" : "This field is required.";
    //tempErrors.min_experience = data.min_experience ? "" : "This field is required.";
    //tempErrors.max_experience = data.max_experience ? "" : "This field is required.";
    tempErrors.locations =
      data.locations.length > 0 ? "" : "This field is required.";
    tempErrors.skills =
      data.skills.length > 0
        ? data.skills.length < 5
          ? "At least 5 skills are required."
          : ""
        : "This field is required.";
    tempErrors.job_position = data.job_position
      ? ""
      : "This field is required.";
    tempErrors.job_ctc = data.job_ctc ? "" : "This field is required.";
    tempErrors.job_details = data.job_details ? "" : "This field is required.";
    tempErrors.job_types =
      data.job_types.length > 0 ? "" : "This field is required.";
      tempErrors.industryicon = data.industryicon ? "" : "This field is required.";
    setErrors(tempErrors);
    return Object.values(tempErrors).every((x) => x === "");
  };

  const handleSubmit = async () => {
    if (validate()) {
      setLoading(true);
      try {
        const updatedData = {
          ...data,
          skills: data.skills.map((skill) => skill.value).join(","),
          locations: data.locations.map((location) => location.value).join(","),
          job_types: data.job_types.map((jt) => jt.value).join(","),
          status: data.published,
        };
        let res = await updateJobAPI(jobId, updatedData);
        if (res !== false) {
          if (res?.error && res.error !== "undefined") {
            swal("Error", res.error, "error");
          } else {
            swal("Success", "Job updated successfully", "success");
            navigate("/job_list");
          }
        } else {
          swal(
            "Error",
            "There was an error updating the job. Please contact administrator!",
            "error"
          );
        }
      } catch (error) {
        swal("Error", "There was an error updating the job", "error");
      } finally {
        setLoading(false);
      }
    }
  };

  const saveEditorValue = useCallback(
    (name, value) => {
      setData({
        ...data,
        [name]: value,
      });
    },
    [setData, data]
  );

  const handleCheckBoxes = useCallback(
    (e) => {
      const data = [
        ...document.querySelectorAll('input[name="identity"]:checked'),
      ].map((e) => e.value);
      setData((pre) => ({ ...pre, identity: data.join(",") }));
    },
    [setData]
  );

  console.log(data.industryicon);
  

  return (
    <div className="container mt-5">
      <div className="d-flex align-items-center mb-4 flex-wrap">
        <h4 className="fs-20 font-w600 me-auto">{""}</h4>
        <Link to="/job_list" className="btn btn-primary me-3 btn-sm">
          <i className="fas fa-plus me-2"></i>Back to Listing
        </Link>
      </div>

      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Job Details</h4>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Recruiter</label>
                  <select
                    name="company_id"
                    className="form-select"
                    onChange={handleChange}
                    value={data.company_id}
                  >
                    <option value="">Select Recruiter</option>
                    {companies?.map((cmp) => (
                      <option key={cmp.id} value={cmp.id}>
                        {cmp.company_name}
                      </option>
                    ))}
                  </select>
                  {errors.company_id && (
                    <div className="text-danger">{errors.company_id}</div>
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Company Name</label>
                  <input
                    type="text"
                    name="company_name"
                    className="form-control"
                    onChange={handleChange}
                    value={data.company_name}
                  />
                  {errors.company_name && (
                    <div className="text-danger">{errors.company_name}</div>
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Job Title</label>
                  <input
                    type="text"
                    name="job_title"
                    className="form-control"
                    onChange={handleChange}
                    value={data.job_title}
                  />
                  {errors.job_title && (
                    <div className="text-danger">{errors.job_title}</div>
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Min Experience</label>
                      <input
                        type="number"
                        name="min_experience"
                        className="form-control"
                        onChange={handleChange}
                        value={data.min_experience}
                      />
                      {errors.min_experience && (
                        <div className="text-danger">
                          {errors.min_experience}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Max Experience</label>
                      <input
                        type="number"
                        name="max_experience"
                        className="form-control"
                        onChange={handleChange}
                        value={data.max_experience}
                      />
                      {errors.max_experience && (
                        <div className="text-danger">
                          {errors.max_experience}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Location</label>
                  <Select
                    isMulti
                    name="locations"
                    options={locations.map((location) => ({
                      value: location.id,
                      label: location.city_name,
                    }))}
                    className="basic-multi-select"
                    classNamePrefix="Select Location"
                    onChange={handleLocationsChange}
                    value={data.locations}
                  />
                  {errors.locations && (
                    <div className="text-danger">{errors.locations}</div>
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Skills</label>
                  <CreatableSelect
                    isMulti
                    name="skills"
                    options={skills.map((skill) => ({
                      value: skill.id,
                      label: skill.skill_title,
                    }))}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    onChange={handleSkillsChange}
                    value={data.skills}
                  />
                  {errors.skills && (
                    <div className="text-danger">{errors.skills}</div>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Industry Icon</label>
                  {/* onChange={handleChange}
                    value={data.company_id} */}
                  <select
                    name="industryicon"
                    className="form-select"
                    onChange={handleChange}
                    value={data.industryicon}
                    //defaultValue={data.industryicon}
                  >
                    <option value="">Select Icon</option>
                    <option value="realestate.png">Realestate</option>
                    <option value="it.png">IT</option>
                    <option value="bfsi.png">BFSI</option>
                    <option value="manufracturing.png">Manufracturing</option>
                    <option value="fmcg.png">FMCG</option>
                    <option value="pharma.png">Pharma</option>
                    <option value="we-are-hiring-2.png">We are hiring</option>
                  </select>
                  {errors.industryicon && (
                    <div className="text-danger">{errors.industryicon}</div>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Job Position</label>
                  <input
                    type="text"
                    name="job_position"
                    className="form-control"
                    onChange={handleChange}
                    value={data.job_position}
                  />
                  {errors.job_position && (
                    <div className="text-danger">{errors.job_position}</div>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Job CTC</label>
                  <input
                    type="text"
                    name="job_ctc"
                    className="form-control"
                    onChange={handleChange}
                    value={data.job_ctc}
                  />
                  {errors.job_ctc && (
                    <div className="text-danger">{errors.job_ctc}</div>
                  )}
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Job Types</label>
                  <Select
                    isMulti
                    name="job_types"
                    options={jobTypes.map((job_type) => ({
                      value: job_type.id,
                      label: job_type.title,
                    }))}
                    className="basic-multi-select"
                    classNamePrefix="Select Job Types"
                    onChange={handleJobTypesChange}
                    value={data.job_types}
                  />
                  {errors.job_types && (
                    <div className="text-danger">{errors.job_types}</div>
                  )}
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Job Sector</label>
                  <div className="contact-name">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="job_sector"
                      value="1"
                      id="job_sector1"
                      checked={data.job_sector == "1"}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="statusActive">
                      Tech &nbsp;&nbsp;&nbsp;
                    </label>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="job_sector"
                      value="0"
                      id="job_sector2"
                      onChange={handleChange}
                      checked={data.job_sector != "1"}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="statusInactive"
                    >
                      Non-Tech
                    </label>
                    {errors.job_sector && (
                      <div className="text-danger">{errors.job_sector}</div>
                    )}
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Talent Pool</label>
                  <div className="contact-name">
                    <label className="me-3">
                      <input
                        onChange={handleCheckBoxes}
                        type="checkbox"
                        name="identity"
                        className="form-check-input"
                        value="1"
                        checked={data.identity?.includes("1")}
                      />
                      &nbsp;&nbsp;LGBT+ Talent
                    </label>
                    <label className="me-3">
                      <input
                        className="form-check-input"
                        onChange={handleCheckBoxes}
                        type="checkbox"
                        name="identity"
                        value="3"
                        checked={data.identity?.includes("3")}
                      />
                      &nbsp;&nbsp;Women Talent
                    </label>
                    {roleID == "1" && (
                      <label className="me-3">
                        <input
                          className="form-check-input"
                          onChange={handleCheckBoxes}
                          type="checkbox"
                          name="identity"
                          value="2"
                          checked={data.identity?.includes("2")}
                        />
                        &nbsp;&nbsp;Man Talent
                      </label>
                    )}
                    <span className="validation-text"></span>
                    {errors.identity && (
                      <div className="text-danger">{errors.identity}</div>
                    )}
                  </div>
                </div>
                <div className="col-md-12 mb-3">
                  <label className="form-label">Job Details</label>
                  {/* <CKEditor
                    editor={ClassicEditor}
                    data={data.job_details}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setData((prevState) => ({
                        ...prevState,
                        job_details: data,
                      }));
                    }}
                  /> */}

                  {data?.job_details && (
                    <DraftEditor
                      setEditorValue={saveEditorValue}
                      fieldName="job_details"
                      ipValue={data?.job_details}
                    />
                  )}

                  {errors.job_details && (
                    <div className="text-danger">{errors.job_details}</div>
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Job Publish Schedule</label>
                  <DatePicker
                    selected={data.job_publish_schedule}
                    onChange={(date) =>
                      handleDateChange(date, "job_publish_schedule")
                    }
                    className="form-control"
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Application Deadline</label>
                  <DatePicker
                    selected={data.application_deadline}
                    onChange={(date) =>
                      handleDateChange(date, "application_deadline")
                    }
                    className="form-control"
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Add to Hot Jobs</label>
                  <div className="contact-name">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="add_to_hot_jobs"
                      value="1"
                      id="add_to_hot_jobs1"
                      checked={data.add_to_hot_jobs == "1"}
                      onChange={handleChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="add_to_hot_jobs1"
                    >
                      Yes &nbsp;&nbsp;&nbsp;
                    </label>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="add_to_hot_jobs"
                      value="0"
                      id="add_to_hot_jobs2"
                      checked={data.add_to_hot_jobs != "1"}
                      onChange={handleChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="add_to_hot_jobs2"
                    >
                      No
                    </label>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">
                    Show Popup: How Did You Know?
                  </label>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="show_popup_how_did_you_know"
                      id="show_popup_how_did_you_know"
                      checked={data.show_popup_how_did_you_know}
                      onChange={(e) =>
                        setData((prevState) => ({
                          ...prevState,
                          show_popup_how_did_you_know: e.target.checked,
                        }))
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="show_popup_how_did_you_know"
                    >
                      Yes
                    </label>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Profile Image</label>
                  <input
                    type="file"
                    name="profile_image"
                    className="form-control"
                    onChange={handleFileChange}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Status</label>
                  <div className="contact-name">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="published"
                      value="1"
                      id="statusActive"
                      checked={data.published === "1"}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="statusActive">
                      Active &nbsp;&nbsp;&nbsp;
                    </label>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="published"
                      value="0"
                      id="statusInactive"
                      onChange={handleChange}
                      checked={data.published !== "1"}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="statusInactive"
                    >
                      Inactive
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center">
        <button
          type="submit"
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Loading..." : "Update Job"}
        </button>
      </div>
    </div>
  );
};

export default EditJobs;
